// extracted by css-extract-rspack-plugin
export default {"label":"InfoItem-module__label__YQPQOnF","wrapper":"InfoItem-module__wrapper__tzdK7NY","isInline":"InfoItem-module__isInline__DKdk3j9"};